export default __webpack_public_path__ + "../staticImages/sprite-google-pay-2x.png";